(function(){
  const STORAGE_KEY = 'consent.v1';
  const DEBUG = window.location.search.includes('consent_debug=true');
  
  const THEME_SETTINGS = window.KIANUSH_CONSENT_SETTINGS || {};
  const STRICT_MODE = THEME_SETTINGS.strict_gdpr_mode || false;
  const DISABLE_SHOPIFY = THEME_SETTINGS.disable_shopify_analytics || false;
  
  function log(...args) {
    if (DEBUG) console.log('[KIANUSH Consent]', ...args);
  }

  const hasShopify = !!(window.Shopify && window.Shopify.customerPrivacy);

  window.dataLayer = window.dataLayer || [];
  function gtag(){ dataLayer.push(arguments); }
  
  // Set default consent state to denied
  gtag('consent', 'default', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    functionality_storage: 'granted', // Essential cookies
    security_storage: 'granted', // Security cookies
    wait_for_update: 500
  });

  // Get consent from localStorage
  const getLocal = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch (e) {
      log('Error reading localStorage:', e);
      return null;
    }
  };

  // Save consent to localStorage
  const setLocal = (consent) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        ...consent,
        timestamp: Date.now()
      }));
      log('Saved consent to localStorage:', consent);
    } catch (e) {
      log('Error saving to localStorage:', e);
    }
  };

  // Get current consent state
  async function getConsent() {
    // Try Shopify Customer Privacy API first
    if (hasShopify && window.Shopify.customerPrivacy.getTrackingConsent) {
      try {
        const granted = await window.Shopify.customerPrivacy.getTrackingConsent();
        const categories = await window.Shopify.customerPrivacy.currentPrivacyConsent?.() || {};
        log('Got consent from Shopify:', { granted, categories });
        return {
          granted,
          analytics: !!categories.analytics,
          marketing: !!categories.marketing,
          preferences: !!categories.preferences
        };
      } catch (e) {
        log('Error getting Shopify consent:', e);
      }
    }
    
    // Fallback to localStorage
    const local = getLocal();
    if (local) {
      log('Got consent from localStorage:', local);
    }
    return local;
  }

  // Set consent state
  async function setConsent(categories) {
    log('Setting consent:', categories);
    
    // Update Shopify Customer Privacy API if available
    if (hasShopify && window.Shopify.customerPrivacy.setTrackingConsent) {
      try {
        await window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!categories.analytics,
          marketing: !!categories.marketing,
          preferences: !!categories.preferences,
          sale_of_data: false
        });
        log('Updated Shopify consent');
      } catch (e) {
        log('Error updating Shopify consent:', e);
      }
    }
    
    // Always save to localStorage as fallback
    setLocal({
      granted: !!(categories.analytics || categories.marketing || categories.preferences),
      ...categories
    });
    
    // Update Google Consent Mode
    gtag('consent', 'update', {
      ad_storage: categories.marketing ? 'granted' : 'denied',
      analytics_storage: categories.analytics ? 'granted' : 'denied',
      ad_user_data: categories.marketing ? 'granted' : 'denied',
      ad_personalization: categories.marketing ? 'granted' : 'denied'
    });
    
    // Dispatch custom event for other scripts to listen to
    window.dispatchEvent(new CustomEvent('consent:update', {
      detail: categories,
      bubbles: true
    }));
  }

  // Show consent banner
  function showBanner() {
    const banner = document.getElementById('consent-banner');
    if (banner) {
      banner.removeAttribute('hidden');
      setTimeout(() => banner.classList.add('show'), 10);
      log('Banner shown');
    }
  }

  // Hide consent banner
  function hideBanner() {
    const banner = document.getElementById('consent-banner');
    if (banner) {
      banner.classList.remove('show');
      setTimeout(() => banner.setAttribute('hidden', ''), 300);
      log('Banner hidden');
    }
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', async () => {
    log('Consent controller initializing...');
    
    const acceptBtn = document.getElementById('consent-accept');
    const denyBtn = document.getElementById('consent-deny');
    
    // Check current consent state
    const state = await getConsent();
    log('Current consent state:', state);
    
    // Show banner if no valid consent
    if (!state || state.granted !== true) {
      showBanner();
    } else {
      // Fire update event with current state for scripts that are already loaded
      window.dispatchEvent(new CustomEvent('consent:update', {
        detail: state,
        bubbles: true
      }));
    }
    
    // Handle accept button
    acceptBtn?.addEventListener('click', () => {
      log('User accepted all cookies');
      const consent = {
        analytics: true,
        marketing: true,
        preferences: true
      };
      hideBanner();
      setConsent(consent).then(() => {
        // Reload to apply consent (ensures all scripts load properly)
        if (!DEBUG) location.reload();
      });
    });
    
    // Handle deny button
    denyBtn?.addEventListener('click', () => {
      log('User accepted only necessary cookies');
      const consent = {
        analytics: false,
        marketing: false,
        preferences: false
      };
      hideBanner();
      setConsent(consent).then(() => {
        // No reload needed when denying
      });
    });
    
    // Listen for Shopify consent events
    document.addEventListener('visitorConsentCollected', (event) => {
      log('Shopify consent collected:', event.detail);
      if (event.detail) {
        setConsent({
          analytics: !!event.detail.analytics,
          marketing: !!event.detail.marketing,
          preferences: !!event.detail.preferences
        });
      }
    });
    
    // Hide native Shopify banner if our custom one is shown
    const observer = new MutationObserver(() => {
      const nativeBanners = document.querySelectorAll(
        '[data-shopify="policy-banner"], ' +
        '.shopify-policy-banner, ' +
        'shopify-consent-banner, ' +
        '#shopify-pc__banner'
      );
      
      nativeBanners.forEach(banner => {
        if (banner && banner.style.display !== 'none') {
          banner.style.display = 'none';
          log('Hid native Shopify banner');
        }
      });
    });
    
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true
    });
    
    log('Consent controller ready');
  });
})();